<template>
    <div>
        <table>
            <thead>
            <tr>
                <th rowspan="2">Table</th>
                <th rowspan="2">Column</th>
                <th colspan="5">Live</th>
                <th colspan="5">Dummy</th>
            </tr>
            <tr>
                <th>Type</th>
                <th>Primary</th>
                <th>Nullable</th>
                <th>Default</th>
                <th>Action</th>

                <th>Type</th>
                <th>Primary</th>
                <th>Nullable</th>
                <th>Default</th>
                <th>Action</th>
            </tr>
            </thead>

            <tbody>

            <template v-if="diffs.length > 0" v-for="diff in diffs">
                <tr class="diff-row" v-for="(col, i) in Object.keys(diff.columns.live)">
                    <td v-if="i === 0" :rowspan="diff.column_list.length"><div class="tbl-name">{{ diff.table }}</div></td>
                    <td><span class="col-name">{{ col }}</span></td>

                    <template v-if="!diff.columns.live">
                        <td v-if="i === 0" class="no-data" colspan="5" :rowspan="diff.column_list.length">No Table
                            <span class="sync" @click="sync('live', diff.table)">►</span>
                        </td>
                    </template>
                    <template v-else-if="diff.columns.live[col]">
                        <td><span class="col-type">{{ diff.columns.live[col]['type'] }}</span></td>
                        <td><span class="col-type">{{ diff.columns.live[col]['is_primary'] }}</span></td>
                        <td><span class="col-type">{{ diff.columns.live[col]['is_nullable'] }}</span></td>
                        <td><span class="col-type">{{ diff.columns.live[col]['default'] }}</span></td>
                        <td><span v-if="diff.columns.dummy && diff.columns.dummy[col]" class="sync" @click="sync('live', diff.table, col)">►</span></td>
                    </template>
                    <td v-else colspan="5" class="no-data">No Column
                        <span class="sync" @click="sync('live', diff.table, col)">►</span>
                    </td>

                    <template v-if="!diff.columns.dummy">
                        <td v-if="i === 0" class="no-data" colspan="5" :rowspan="diff.column_list.length">No Table
                            <span class="sync" @click="sync('dummy', diff.table)">►</span>
                        </td>
                    </template>
                    <template v-else-if="diff.columns.dummy[col]">
                        <td><span class="col-type">{{ diff.columns.dummy[col]['type'] }}</span></td>
                        <td><span class="col-type">{{ diff.columns.dummy[col]['is_primary'] }}</span></td>
                        <td><span class="col-type">{{ diff.columns.dummy[col]['is_nullable'] }}</span></td>
                        <td><span class="col-type">{{ diff.columns.dummy[col]['default'] }}</span></td>
                        <td><span v-if="diff.columns.live && diff.columns.live[col]" class="sync" @click="sync('dummy', diff.table, col)">►</span></td>
                    </template>
                    <td v-else colspan="5" class="no-data">No Column
                        <span class="sync" @click="sync('dummy', diff.table, col)">►</span>
                    </td>
                </tr>
            </template>
            <tr>
                <td colspan="12" class="no-data">All Table Is The Same</td>
            </tr>

            </tbody>
        </table>
    </div>
</template>

<script>
import DbApi from "../../../repository/api/DbApi";

export default {
    name: "DbStructureCompare",

    data() {
        return {
            diffs: null
        }
    },

    mounted() {
        this.getData()
    },

    methods: {
        getData() {
            DbApi.compare()
                .then(r => {
                    this.diffs = Object.keys(r).map(x => ({
                        table: x,
                        columns: r[x],
                        column_list: r[x].live ? Object.keys(r[x].live) : r[x].dummy ? Object.keys(r[x].dummy) : [],
                    }))
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        sync(server, table, column = null) {
            this.$swal({
                title: "Synchronize",
                text: `Synchronize ${ column ? `'${column}' column on '${table}' table` : `'${table}' table` } on '${server}' server?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: `Cancel`,
            }).then((result) => {
                if (result.isConfirmed) {
                    DbApi.sync(server, table, column)
                        .then(r => {
                            this.getData()
                        })
                        .catch((e) => {
                            this.$swal({
                                icon: e.severity || "error",
                                title: (e.severity || "error").toUpperCase(),
                                text: e.message,
                            })
                        })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">

table {
    width: 100%;
    border-top: 1px solid #8a9ca1;
    border-right: 1px solid #8a9ca1;
}

th {
    text-align: center;
    border-bottom: 1px solid #8a9ca1;
    border-left: 1px solid #8a9ca1;
    background: rgba(0, 0, 0, 0.1);
    padding: 4px;
}

td {
    border-bottom: 1px solid #8a9ca1;
    border-left: 1px solid #8a9ca1;
    padding: 10px 6px;
    vertical-align: top;
}

.tbl-name, .col-name {
    color: #1e5475;
    font-weight: bold;
}

.no-data {
    text-align: center;
    vertical-align: middle;
}

.sync {
    color: #2f7ab4;
    padding: 3px;
    border-radius: 6px;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
        color: #1f6296;
    }
}

</style>